import React from 'react';
export function ServiceClosingCta() {
  return <section className="w-full bg-brand-navy py-12 md:py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-288" data-mp="eyaxb2x893m6">
      <div className="max-w-4xl mx-auto" data-id="element-289" data-mp="3759k04pxy8z4">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-290" data-mp="2tf66c254nnla">
          Every team is different. Let's figure out what yours needs.
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-291" data-mp="2jgglq1lujp1c">
          Book a 30-minute call and we'll talk through where your team is and
          what would actually move the needle.
        </p>
        <div className="flex flex-col items-center space-y-6" data-id="element-292" data-mp="2agk1cc6hpcc3">
          <a href="https://scheduler.zoom.us/breakapencil/intro-call-30" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-293" data-mp="2feveowvzu4z2">
            Book a Call
          </a>
          <p className="text-white text-base" data-id="element-294" data-mp="1e2z7uh42oqes">
            Or email me directly:{' '}
            <a href="mailto:michael@breakapencil.com" className="text-white border-b-2 border-brand-orange hover:text-brand-orange transition-colors pb-0.5" data-id="element-295" data-mp="1rtaz6dsu2l4v">
              michael@breakapencil.com
            </a>
          </p>
        </div>
      </div>
    </section>;
}